/* eslint-disable camelcase */
import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import * as jwt from 'services/jwt'
import actions from './actions'

const jwts = {
  startYearlySubscription: jwt.startYearlySubscription,
  cancelYearlySubscription: jwt.cancelYearlySubscription,
  getYearlySubscriptionStatus: jwt.getYearlySubscriptionStatus,
  getYearlySubscriptionHistory: jwt.getYearlySubscriptionHistory,
  getYearlySubscriptionDeductions: jwt.getYearlySubscriptionDeductions,
}

export function* START_SUBSCRIPTION({ payload }) {
  yield put({
    type: 'subscription/SET_STATE',
    payload: { startLoading: true },
  })
  const success = yield call(jwts.startYearlySubscription, payload)
  if (success && success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { startLoading: false },
    })
    notification.success({
      message: 'Success!',
      description: success.message || 'Subscription deduction started successfully.',
    })
    yield put({ type: 'subscription/GET_SUBSCRIPTION_STATUS' })
    yield put({ type: 'subscription/GET_SUBSCRIPTION_HISTORY' })
  }
  if (!success || !success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { startLoading: false },
    })
    notification.error({
      message: 'Error!',
      description: success?.message || 'Failed to start subscription deduction.',
    })
  }
}

export function* GET_SUBSCRIPTION_STATUS() {
  yield put({
    type: 'subscription/SET_STATE',
    payload: { statusLoading: true },
  })
  const success = yield call(jwts.getYearlySubscriptionStatus)
  if (success && success.status && success.data) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: {
        statusLoading: false,
        subscriptionStatus: success.data,
      },
    })
  } else {
    yield put({
      type: 'subscription/SET_STATE',
      payload: {
        statusLoading: false,
        subscriptionStatus: {},
      },
    })
  }
}

export function* GET_SUBSCRIPTION_HISTORY() {
  yield put({
    type: 'subscription/SET_STATE',
    payload: { loading: true },
  })
  const success = yield call(jwts.getYearlySubscriptionHistory)
  if (success && success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: {
        loading: false,
        subscriptionHistory: success?.data,
      },
    })
  }
  if (!success || !success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { loading: false },
    })
    notification.error({
      message: 'Error!',
      description: success?.message || 'Failed to fetch subscription history.',
    })
  }
}

export function* GET_SUBSCRIPTION_DEDUCTIONS({ payload }) {
  yield put({
    type: 'subscription/SET_STATE',
    payload: { deductionsLoading: true },
  })
  const success = yield call(jwts.getYearlySubscriptionDeductions, payload)
  if (success && success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: {
        deductionsLoading: false,
        deductions: success?.data,
      },
    })
  }
  if (!success || !success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { deductionsLoading: false, deductions: {} },
    })
    notification.error({
      message: 'Error!',
      description: success?.message || 'Failed to fetch deductions.',
    })
  }
}

export function* CANCEL_SUBSCRIPTION({ payload }) {
  yield put({
    type: 'subscription/SET_STATE',
    payload: { cancelLoading: true },
  })
  const success = yield call(jwts.cancelYearlySubscription, payload)
  if (success && success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { cancelLoading: false },
    })
    notification.success({
      message: 'Success!',
      description: success.message || 'Subscription deduction cancelled successfully.',
    })
    yield put({ type: 'subscription/GET_SUBSCRIPTION_STATUS' })
    yield put({ type: 'subscription/GET_SUBSCRIPTION_HISTORY' })
  }
  if (!success || !success.status) {
    yield put({
      type: 'subscription/SET_STATE',
      payload: { cancelLoading: false },
    })
    notification.error({
      message: 'Error!',
      description: success?.message || 'Failed to cancel subscription deduction.',
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.START_SUBSCRIPTION, START_SUBSCRIPTION),
    takeEvery(actions.CANCEL_SUBSCRIPTION, CANCEL_SUBSCRIPTION),
    takeEvery(actions.GET_SUBSCRIPTION_STATUS, GET_SUBSCRIPTION_STATUS),
    takeEvery(actions.GET_SUBSCRIPTION_HISTORY, GET_SUBSCRIPTION_HISTORY),
    takeEvery(actions.GET_SUBSCRIPTION_DEDUCTIONS, GET_SUBSCRIPTION_DEDUCTIONS),
  ])
}
